export const MESSAGE_PREFERENCE = {
  SEND_ON_ENTER: 'sendOnEnter',
  NEWLINE_ON_ENTER: 'newLineOnEnter'
};

export const DEFAULT_INBOX_SETTINGS = {
  messagePreference: MESSAGE_PREFERENCE.SEND_ON_ENTER,
  // auto assign member who reply conversation
  isAutoAssignment: true,
  isAssignSequentially: false
};
